/**
 * /render-export/:id/:style — diagnostic page that mounts ExportCard at the
 * target export dimensions so we can visually verify the html-to-image
 * fallback path matches the MoodCard in-app view.
 *
 * Used only for QA / smoke-tests — not linked from the public UI.
 */
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import ExportCard from "../components/ExportCard";

const API = `${window.location.origin}/api`;

const ASPECT_SIZES = {
    story:    { w: 1080, h: 1920 },
    feed:     { w: 1080, h: 1080 },
    portrait: { w: 1080, h: 1350 },
    x:        { w: 1200, h: 675  },
};

export default function ExportCardPreview() {
    const { id, style } = useParams();
    const [search] = useSearchParams();
    const aspect = search.get("aspect") || "story";
    const dims = ASPECT_SIZES[aspect] || ASPECT_SIZES.story;
    const [mood, setMood] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get(`${API}/moodcards/${id}`);
                setMood(data);
            } catch { /* ignore */ }
        })();
    }, [id]);

    if (!mood) return <div style={{ color: "#fff", padding: 24 }}>loading…</div>;
    const card = mood.cards?.find((c) => c.style === style) || mood.cards?.[0];
    if (!card) return <div style={{ color: "#fff", padding: 24 }}>style not found</div>;

    return (
        <div style={{ background: "#0a0a0e", minHeight: "100vh", padding: 20 }}>
            <div style={{ color: "#fff", marginBottom: 16, fontFamily: "monospace", fontSize: 12 }}>
                ExportCard preview · {dims.w}×{dims.h} · style={style} · aspect={aspect}
            </div>
            <ExportCard
                card={card}
                width={dims.w}
                height={dims.h}
                showWatermark={mood.watermark_required !== false}
                lane={mood.lane || mood.personalize?.lane || null}
                temperature={mood.personalize?.temperature || mood.temperature || null}
            />
        </div>
    );
}
